import { jsx as e, Fragment as l, jsxs as c } from "react/jsx-runtime";
import { c as y } from "./clsx-OuTLNxxd.js";
import "./Label.css?__remix_sideEffect__";const g = "320px",h = "600px",a = "1025px",d = "_isVisuallyHidden_14bu5_52",m = "_label_14bu5_64",f = "_hasMobileText_14bu5_71",t = {
    mobile: g,
    "mobile-wide": "480px",
    tablet: h,
    "tablet-wide": "800px",
    desktop: a,
    "desktop-mid": "1281px",
    "desktop-large": "1360px",
    "heading-l": "--cxy-fontSize-xxxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-extraBold",
    "heading-l-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-extraBold",
    "heading-m": "--cxy-fontSize-xxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-semiBold",
    "heading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-semiBold",
    "heading-s": "--cxy-fontSize-xxl, --cxy-lineHeight-xl, --cxy-fontWeight-extraBold",
    "subHeading-l": "--cxy-fontSize-xl, --cxy-lineHeight-l, --cxy-fontWeight-bold",
    "subHeading-m": "--cxy-fontSize-l, --cxy-lineHeight-xs, --cxy-fontWeight-normal",
    "subHeading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-light",
    "subHeading-s": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
    "subHeading-s-mobile": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
    "button-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
    "button-s": "--cxy-fontSize-s, --cxy-lineHeight-xs, --cxy-fontWeight-semiBold",
    "button-xs": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
    "button-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
    "text-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
    "text-s": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
    "text-xs": "--cxy-fontSize-xs, --cxy-lineHeight-m, --cxy-fontWeight-semiBold",
    "text-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxxs, --cxy-fontWeight-normal",
    isVisuallyHidden: d,
    label: m,
    hasMobileText: f,
    "size-s": "_size-s_14bu5_86",
    "size-m": "_size-m_14bu5_93",
    "size-l": "_size-l_14bu5_99"
  },z = ({
    className: n,
    children: x,
    size: s = "m",
    mobileText: i,
    ...o
  }) => /* @__PURE__ */e(
    "label",
    {
      className: y(
        t.label,
        t[`size-${s}`],
        { [t.hasMobileText]: !!i },
        n
      ),
      ...o,
      children: /* @__PURE__ */e(l, { children: i ? /* @__PURE__ */c(l, { children: [
          /* @__PURE__ */e("span", { "data-testid": "mobile-label", children: i }),
          /* @__PURE__ */e("span", { "data-testid": "label", children: x })]
        }) : x })
    }
  );
export {
  z as L };